import React, { useEffect, useState } from 'react';
import { WebGLCheck } from './components/WebGLCheck';
import { LoginPage } from './components/auth/LoginPage';
import { SignupPage } from './components/auth/SignupPage';
import { SessionExpiredPage } from './components/auth/SessionExpiredPage';
import { useAuthStore } from './store/useAuthStore';
import './App.css';

type AuthView = 'loading' | 'login' | 'signup' | 'session-expired' | 'app';

function App() {
  const { isAuthenticated, isLoading, fetchMe } = useAuthStore();
  const [authView, setAuthView] = useState<AuthView>('loading');
  const [sessionExpiredRedirect, setSessionExpiredRedirect] = useState<string | undefined>();

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  useEffect(() => {
    if (!isLoading) {
      setAuthView(isAuthenticated ? 'app' : 'login');
    }
  }, [isLoading, isAuthenticated]);

  const handleNavigate = (view: string) => {
    if (view.startsWith('login')) {
      setAuthView('login');
    } else if (view === 'signup') {
      setAuthView('signup');
    } else if (view.startsWith('session-expired')) {
      setSessionExpiredRedirect(new URLSearchParams(view.split('?')[1]).get('redirect') ?? undefined);
      setAuthView('session-expired');
    } else {
      setAuthView('app');
    }
  };

  if (authView === 'loading') {
    return <div style={{ backgroundColor: '#0E1420', width: '100vw', height: '100vh' }} />;
  }
  if (authView === 'login') {
    return <LoginPage onNavigate={handleNavigate} />;
  }
  if (authView === 'signup') {
    return <SignupPage onNavigate={handleNavigate} />;
  }
  if (authView === 'session-expired') {
    return <SessionExpiredPage onNavigate={handleNavigate} redirectPath={sessionExpiredRedirect} />;
  }

  return <WebGLCheck />;
}

export default App;
